import { useTheme } from '../context/ThemeContext';
import { Apple, Play } from 'lucide-react';

const CTA = ({ onDownloadClick }) => {
  const theme = useTheme();

  return (
    <section 
      id="cta" 
      className="py-32 relative overflow-hidden"
      style={{ backgroundColor: theme.background }}
    >
      {/* Background gradient blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full blur-3xl opacity-20"
          style={{ background: `linear-gradient(135deg, ${theme.gradientStart}, ${theme.gradientEnd})` }}
        />
      </div>

      <div className="container-app relative z-10">
        <div className="text-center max-w-2xl mx-auto">
          
          {/* Logo */}
          <img 
            src="/logo.png" 
            alt="TripData" 
            className="h-16 md:h-20 object-contain mx-auto mb-8"
          />

          {/* Headline */}
          <h2 
            className="text-responsive-lg font-bold tracking-tight mb-6"
            style={{ color: theme.text }}
          >
            Ready to track{' '}
            <span className="gradient-text">smarter?</span>
          </h2>

          {/* Subtitle */}
          <p 
            className="text-xl mb-10"
            style={{ color: theme.textSecondary }}
          >
            Join thousands of drivers who'll simplify their mileage tracking. 
            Launching April 2026.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onDownloadClick}
              className="btn btn-gradient gap-2"
            >
              <Apple size={20} />
              App Store
            </button>
            <button 
              onClick={onDownloadClick}
              className="btn gap-2 bg-transparent border border-primary text-primary hover:bg-primary hover:text-white transition-all"
            >
              <Play size={20} />
              Google Play
            </button>
          </div>

          {/* Bottom note */}
          <p 
            className="text-sm mt-8"
            style={{ color: theme.textMuted }}
          >
            Free to download. No credit card required.
          </p>

        </div>
      </div>
    </section>
  );
};

export default CTA;